import { render, staticRenderFns } from "./EducationDetailsSkeleton.vue?vue&type=template&id=df42e5dc&scoped=true"
import script from "./EducationDetailsSkeleton.vue?vue&type=script&lang=js"
export * from "./EducationDetailsSkeleton.vue?vue&type=script&lang=js"
import style0 from "./EducationDetailsSkeleton.vue?vue&type=style&index=0&id=df42e5dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df42e5dc",
  null
  
)

export default component.exports